const formatRelativeTime = (isoDate: string): string => {
  const diffMs = Date.now() - new Date(isoDate).getTime();
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHr = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHr / 24);

  if (diffSec < 60) return 'just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  if (diffHr < 24) return `${diffHr}h ago`;
  const dateTime = new Date(isoDate);
  const timeStr = dateTime.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  if (diffDay === 1) return `yesterday ${timeStr}`;
  if (diffDay < 7) return `${diffDay}d ago ${timeStr}`;
  return dateTime.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) + ` ${timeStr}`;
};

export { formatRelativeTime };
